import { html } from "htm/preact";

import type * as Bible from "../modules/bible";

import { useBibleSettings } from "./BibleContent";

export const BibleContentVerseImage = ({
  image,
}: {
  image: Bible.ContentVerseImage;
}) => {
  const settings = useBibleSettings();
  const renderNarrative =
    settings.showNarrativeImages && image.payload.type === "narrative";
  const renderUnit = settings.showUnitImages && image.payload.type === "unit";
  if (renderNarrative || renderUnit) {
    return html`<span
      class="BibleContentVerseImage"
      data-type=${image.payload.type}
      style=${{
        paddingTop: `${
          100 / (image.payload.aspect_ratio /* c8 ignore next */ ?? 1)
        }%`,
      }}
      ><img src=${image.payload.url}
    /></span>`;
  }
  return null;
};
